import { useState, useEffect, useRef } from "react";
import AnimateHeight from "react-animate-height";

import Series_List from "./Series_List";

function Series_List_Set({
  listGroupObj,
  fillSelectionWithList,
  createWholeSeries,
  duplicateSelectionArray,
  fillWithListSelectionArray,
  handleChildOpenToggle,
}) {
  const [groupOpen, setGroupOpen] = useState(false);

  const content = useRef(null);

  function handleToggleOpen() {
    setGroupOpen(!groupOpen);
  }

  return (
    <div
      ref={content}
      className="grid cs1 ce12 mb-8 pb-8 border-top accordion">
      <div
        className="cs1 ce12 grid tool-series-group-header"
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <h4 className="h4 cs1 ce11 mt-0 mb-0 bold mt-8">
          {listGroupObj.group_title}
        </h4>
        <div
          className={
            "cs12 icon m2 mb-0 mt-8 cursor-pointer" +
            " " +
            (groupOpen === false ? "icon-arrow-right" : "icon-arrow-down")
          }></div>
      </div>

      <AnimateHeight
        id="example-panel"
        duration={500}
        height={groupOpen ? "auto" : 0}
        className="cs1 ce12"
        easing="cubic-bezier(0, 1, 0.5, 1)"
      >
        {Object.keys(listGroupObj.group_lists).map((list_key) => {
          return (
            <Series_List
              key={list_key}
              fillSelectionWithList={fillSelectionWithList}
              createWholeSeries={createWholeSeries}
              seriesListObj={listGroupObj.group_lists[list_key]}
              fillWithListSelectionArray={fillWithListSelectionArray}
              duplicateSelectionArray={duplicateSelectionArray}
              handleChildOpenToggle={handleChildOpenToggle}
            />
          );
        })}
      </AnimateHeight>
    </div>
  );
}

export default Series_List_Set;
